export default {
  updateTotalPage(state, payload) {
    state.TotalInfo = payload;
  },
  updateSupplier(state, payload) {
    state.Supplier = payload;
  },
  updateSuppliers(state, payload) {
    state.Suppliers = payload;
  },
};
